import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify);
const Config = require('../config')

export default new Vuetify({
    options: {
        customProperties: true
    },
    icons: {
        iconfont: 'fa',
    },
    theme: {
        themes: {
            light: {
                primary: '#ffad00',
                secondary: Config.LufthansaColors.sky_blue_1,
                font: Config.LufthansaColors.blue_deep

            }
        },
    },
});
